import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  InputAdornment,
  IconButton,
  Typography,
  FormControl,
  InputLabel,
  FilledInput,
} from "@mui/material";
import { ArrowForward as ArrowForwardIcon, Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from '@mui/icons-material';
import CloseIcon from "@mui/icons-material/Close";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { doLogin } from "../lib/auth";

/**
 * Props:
 * - open: boolean
 * - slotId: string | number
 * - slotLabel: string
 * - initialValues?: { nombre?: string, documento?: string }  // para ocupar o para liberar (puede venir prellenado)
 * - onCancel: () => void
 * - onConfirm: (payload: { slotId, slotLabel, nombre, documento }) => void
 */

const PasswordInput = ({ password, setPassword, showPassword, setShowPassword }) => {

  const handleChangePassword = (event) => {
    setPassword(event.target.value);
  }

  return <FormControl className='' variant="filled">
    <InputLabel htmlFor="filled-adornment-password">Contraseña</InputLabel>
    <FilledInput
      id="filled-adornment-password"
      type={showPassword ? 'text' : 'password'}
      value={password}
      onChange={handleChangePassword}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={() => {setShowPassword(!showPassword)}}
            // onMouseDown={handleMouseDownPassword}
            edge="end"
          >
            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </IconButton>
        </InputAdornment>
      }
    />
  </FormControl>
}

export default function LoginDialog({
  open,
  onCancel,
  onConfirm,
  setUsuario,
  setLoadingOpen,
}) {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);

  const loginUser = () => {
    const data = {
      username: username,
      password
    };
    doLogin(data, setUsuario);
  }

  React.useEffect(() => {
    setLoadingOpen(false);
  }, []);

  const handleConfirmar = () => {
    onConfirm?.({username, password});
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      sx={{zIndex: 10}}
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        Parking de Carritos - Login
        {/* <IconButton
          onClick={onCancel}
          aria-label="Cerrar"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField required className='usuario-input' id="filled-search" label="Usuario" variant="filled" value={username} onChange={(event) =>{setUsername(event.target.value)}} />
          <PasswordInput className='password-input'  password={password} setPassword={setPassword} showPassword={showPassword} setShowPassword={setShowPassword} />

        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={handleConfirmar} variant="outlined" >
          Iniciar sesión
        </Button>
      </DialogActions>
    </Dialog>
  );
}
